type notificationDividerProps = {
  data: {
    id: number | string;
    title: string;
    message: string;
    is_admin: boolean;
    is_read: boolean;
  }[];
  type: boolean;
};

export const notificationDivider = ({ data, type }: notificationDividerProps) => {
  if (!data) {
    return {
      adminNotificationCount: 0,
      userNotificationCount: 0,
      filterData: [],
    };
  }
  const adminNotificationCount = data
    .filter((item) => item.is_admin === true && item.is_read === false)
  
  const userNotificationCount = data
    .filter((item) => item.is_admin === false && item.is_read === false)


  const filterData = data.filter((item) => item.is_admin === type);

  return {
    adminNotificationCount: adminNotificationCount.length,
    userNotificationCount: userNotificationCount.length,
    filterData,
  };
};
